/**
 * VAT-Sätze nach Land (DACH)
 * 
 * Feb 2026 — Shared Utility um Doppelung zwischen ExpenseDetail.jsx,
 * AssetCreateWizard.jsx und AssetActivationWizard.jsx zu vermeiden.
 */

export const VAT_RATES_BY_COUNTRY = {
  DE: [
    { rate: 0, label: "0% (steuerfrei)" },
    { rate: 7, label: "7% (DE ermäßigt)" },
    { rate: 19, label: "19% (DE Regel)" },
  ],
  AT: [
    { rate: 0, label: "0% (steuerfrei)" },
    { rate: 4.9, label: "4,9% (AT Grundnahrungsmittel, ab 1.7.2026)" },
    { rate: 10, label: "10% (AT ermäßigt)" },
    { rate: 13, label: "13% (AT Sonder)" },
    { rate: 20, label: "20% (AT Regel)" },
  ],
  CH: [
    { rate: 0, label: "0% (steuerfrei)" },
    { rate: 2.6, label: "2.6% (CH ermäßigt)" },
    { rate: 3.8, label: "3.8% (CH Beherbergung)" },
    { rate: 8.1, label: "8.1% (CH Regel)" },
  ],
};

export const VAT_RATES_OTHER_DACH = {
  DE: [
    { rate: 10, label: "10% (AT)" }, { rate: 13, label: "13% (AT)" }, { rate: 20, label: "20% (AT)" },
    { rate: 2.6, label: "2.6% (CH)" }, { rate: 3.8, label: "3.8% (CH)" }, { rate: 8.1, label: "8.1% (CH)" },
  ],
  AT: [
    { rate: 7, label: "7% (DE)" }, { rate: 19, label: "19% (DE)" },
    { rate: 2.6, label: "2.6% (CH)" }, { rate: 3.8, label: "3.8% (CH)" }, { rate: 8.1, label: "8.1% (CH)" },
  ],
  CH: [
    { rate: 7, label: "7% (DE)" }, { rate: 19, label: "19% (DE)" },
    { rate: 10, label: "10% (AT)" }, { rate: 13, label: "13% (AT)" }, { rate: 20, label: "20% (AT)" },
  ],
};

export const getCountryDefaultRate = (country, position = 0) => {
  const c = (country || "DE").toUpperCase();
  if (position === 0) return c === "AT" ? 20 : c === "CH" ? 8.1 : 19;
  return c === "AT" ? 10 : c === "CH" ? 2.6 : 7;
};

export const getVatRatesForCountry = (country) => {
  const c = (country || "DE").toUpperCase();
  return VAT_RATES_BY_COUNTRY[c] || VAT_RATES_BY_COUNTRY.DE;
};
